import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout";
import { User, Eye, MessageSquare, Image as ImageIcon, Shield, Bell, Globe, Users as UsersIcon, Tag, Heart, Link as LinkIcon } from "lucide-react";

const NAV_KEYS = [
  { slug: "konto",         iconKey: "konto",         icon: User },
  { slug: "profil",        iconKey: "profil",        icon: Eye },
  { slug: "meldinger",     iconKey: "meldinger",     icon: MessageSquare },
  { slug: "par",           iconKey: "par",           icon: Heart },
  { slug: "venner",        iconKey: "venner",        icon: UsersIcon },
  { slug: "innhold",       iconKey: "innhold",       icon: ImageIcon },
  { slug: "selger-lenker", iconKey: "selger_lenker", icon: LinkIcon },
  { slug: "kampanjekoder", iconKey: "kampanjekoder", icon: Tag },
  { slug: "blokkering",    iconKey: "blokkering",    icon: Shield },
  { slug: "varsler",       iconKey: "varsler",       icon: Bell },
  { slug: "sprak",         iconKey: "sprak",         icon: Globe },
];

export default function SettingsLayout({ active, children }) {
  const { t } = useTranslation();
  return (
    <Layout withSidebar={false}>
      <div className="font-meta mb-3">{t("settings.crumb_profile")}</div>
      <h1 className="font-fraunces italic text-5xl text-[var(--cream)] leading-tight mb-10">
        {t("settings.page_title")}
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-10">
        {/* Side-meny */}
        <nav className="lg:sticky lg:top-24 lg:self-start" data-testid="settings-sidenav">
          <ul className="border-y border-white/10 divide-y divide-white/5 lg:border-0 lg:divide-y-0 lg:space-y-1">
            {NAV_KEYS.map((n) => {
              const Icon = n.icon;
              return (
                <li key={n.slug}>
                  <NavLink
                    to={`/innstillinger/${n.slug}`}
                    data-testid={`settings-nav-${n.slug}`}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-3 py-3 border-l-2 transition-colors ${
                        isActive
                          ? "border-[var(--magenta)] bg-white/[0.03] text-[var(--cream)]"
                          : "border-transparent text-[var(--cream-soft)] hover:text-[var(--cream)] hover:bg-white/[0.02]"
                      }`
                    }
                  >
                    <Icon className="h-4 w-4 shrink-0" />
                    <div className="min-w-0">
                      <div className="font-manrope text-sm">{t(`settings.nav.${n.iconKey}`)}</div>
                      <div className="font-manrope text-[11px] text-[var(--cream-faint)] truncate hidden lg:block">
                        {t(`settings.nav_desc.${n.iconKey}`)}
                      </div>
                    </div>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Innhold */}
        <main className="min-w-0 max-w-3xl">{children}</main>
      </div>
    </Layout>
  );
}
